// Author Liang Gangqiang
// Date 2021-04-27 15:13:22

import * as model from "@/model/sithMes/quality/SithMesQualityInspectTemplateDataModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesQualityInspectTemplateData(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_QUALITY_URL,
    })
    .buildStore()
